import { mapCloudCurrenciesToCurrencies } from './mapCloudCurrenciesToCurrencies'

export const normalizeOnboardingApiDetails = (details: Record<string, any>) => {
  if (details.cloudSettings?.cloudCurrencies !== undefined) {
    mapCloudCurrenciesToCurrencies(details.cloudSettings)
  }

  if (details.cloudSettings && details.cloudSettings.stackType === undefined) {
    details.cloudSettings.stackType = 'cloudformation'
  }
  if (
    details.cloudSettings?.stackType === 'terraform' &&
    details.cloudSettings.terraformConnectionValidated === undefined
  ) {
    details.cloudSettings.terraformConnectionValidated = false
  }

  if (details.labraPartnerDetails?.partnershipType) {
    const partnershipType = details.labraPartnerDetails.partnershipType
    if (!Array.isArray(partnershipType)) {
      details.labraPartnerDetails.partnershipType = [partnershipType]
    }
  }

  return details
}
